<template>
    <div class="record-item">
        <span class="record-name" :class="{ autoRecord: isAutoRecord }">{{ recordName }}</span>
        <span class="update-time">{{ recordTime }}</span>
        <div class="load-record" :class="{ autoRecord: isAutoRecord }"
            @click="handleLoadRecord(recordFilePath, recordName)">
            <div class="blue-btn dialog-txt dialog-btn">{{ loadRecordTxt }}</div>
        </div>
        <div v-show="!isAutoRecord" class="delete-record" @click="handleDeleteRecord">
            <div class="red-btn dialog-txt dialog-btn">{{ deleteRecordTxt }}</div>
        </div>
    </div>
</template>

<script>
import SaveTool from '../../../js/toolbar/save_tool';
import AppRenderer from '../../../js/app_renderer';
export default {
    name: "RecordItem",
    data: function () {
        return {
            loadRecordTxt: "開啟紀錄",
            deleteRecordTxt: "刪除"
        }
    },
    props: {
        recordName: String,
        recordTime: String,
        recordFilePath: String,
        recordId: String,
        isAutoRecord: Boolean
    },
    methods: {
        handleLoadRecord(filePath, recordName) {
            AppRenderer.Instance.loadRecord(filePath);
            SaveTool._instance.setSaveDialogRecordName(recordName);
        },
        handleDeleteRecord() {
            console.log("delete record's id: ", this.recordId);
            SaveTool._instance.deleteUserRecord(this.recordId, this.recordName, this.recordFilePath);
        }
    }
}
</script>
<style src="../../../css/dialog_style.css">

</style>

<style scoped>
.record-item {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    margin: 0.8rem 0;
}

.record-name {
    grid-column-start: 2;
    grid-column-end: 5;
    font-size: 1.5rem;
    line-height: 2.5rem;
    text-align: start;
}

.record-name.autoRecord {
    grid-column-start: 3;
}

.update-time {
    grid-column-start: 5;
    grid-column-end: 8;
    font-size: 1rem;
    line-height: 2.5rem;
    text-align: end;
}

.load-record {
    grid-column-start: 9;
    grid-column-end: 11;
}

.load-record.autoRecord {
    grid-column-start: 10;
    grid-column-end: 12;
}
</style>